module.exports = __webpack_public_path__ + "static/media/515.96a816cd.webp";